import { Component, Input, OnInit } from '@angular/core';
import { ContentService } from '@blk/cwp-ng-framework';
import { CellUtil, ComponentData } from '@ddt-web/data-service';
import * as get from 'lodash/get';

@Component({
	selector: 'mb-performance-commentary-text',
	templateUrl: './performance-commentary-text.component.html'
})
export class PerformanceCommentaryTextComponent implements OnInit {
	@Input() public data: ComponentData;
	public performanceCommentaryText: string;

	constructor(private contentService: ContentService) { }

	public ngOnInit(): void {
		if (this.data.success && !get(this.data.getTabById('family.performance.commentary'), 'error')) {
			const cells = get(this.data.getTabById('family.performance.commentary'), 'tableData[0].cells', []);
			const dcrKey = get(CellUtil.getById(cells[0], 'commentaryTypeRef'), 'rawValue', '') + '_PERFORMANCE';
			this.performanceCommentaryText = this.contentService.get(dcrKey, '');
		}
	}
}
